import React from 'react';

import { useConst } from '@wildidea/components/hooks/useConst';

export interface UseIntersectionObserverOptions {
  root?: HTMLElement;
  threshold: number;
}

export const useIntersectionObserver = ({ root, threshold }: UseIntersectionObserverOptions) => {
  const [intersectionMeetsThreshold, setIntersectionMeetsThreshold] = React.useState(false);
  const onIntersectionChanged = useConst((entries: IntersectionObserverEntry[]) => {
    const lastEntry = entries[entries.length - 1];
    setIntersectionMeetsThreshold(lastEntry.isIntersecting);
  });

  // Note that this arrangement means that root and threshold cannot be changed after mount
  // We'd have to nuke the observer and re-bind to the target el which would require considerably
  // more state
  const observer = React.useMemo(
    () => new IntersectionObserver(onIntersectionChanged, { root, threshold }),
    []
  );

  return [
    intersectionMeetsThreshold,
    useConst((el: Element | null) => {
      observer.disconnect();
      if (!el) return;
      observer.observe(el);
    })
  ] as const;
};
